import { View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { resolveContractState } from '@/utils/contractState';
import { STATE_TERMS } from '@/utils/stateTerms';
import { Contract } from '@/types/ContractType';
import Alabama from './Alabama';
import Alaska from './Alaska';
import Arizona from './Arizona';
import Arkansas from './Arkansas';
import California from './California';
import Colorado from './Colorado';
import Connecticut from './Connecticut';
import Delaware from './Delaware';
import DistractofColumbia from './DistractofColumbia';
import Florida from './Florida';
import Georgia from './Georgia';
import Hawaii from './Hawaii';
import Idaho from './Idaho';
import Illinois from './Illinois';
import Indiana from './Indiana';
import Iowa from './Iowa';
import Kansas from './Kansas';
import Kentucky from './Kentucky';
import Louisiana from './Louisiana';
import Maine from './Maine';
import Maryland from './Maryland';
import Massachusetts from './Massachusetts';
import Michigan from './Michigan';
import Minnesota from './Minnesota';
import Mississippi from './Mississippi';
import Missouri from './Missouri';
import Montana from './Montana';
import Nebraska from './Nebraska';
import Nevada from './Nevada';
import NewHampshire from './NewHampshire';
import NewJersey from './NewJersey';
import NewMexico from './NewMexico';
import Ohio from './Ohio';
import Pennsylvania from './Pennsylvania';
import StateTermsListPdf from './StateTermsList';
import Virginia from './Virginia';

const ContractState = ({ contract }: { contract: Contract }) => {
  // Property address first (normalizes "TX" -> "Texas"); agent entry was the
  // only source before, so buyer-drafted contracts had no state terms.
  const state = resolveContractState(contract);
  return (
    <View style={styles.section}>
      {state === 'Alabama' && <Alabama />}
      {state === 'Alaska' && <Alaska />}
      {state === 'Arizona' && <Arizona />}
      {state === 'Arkansas' && <Arkansas />}
      {state === 'California' && <California />}
      {state === 'Colorado' && <Colorado />}
      {state === 'Connecticut' && <Connecticut />}
      {state === 'Delaware' && <Delaware />}
      {state === 'District of Columbia' && <DistractofColumbia />}
      {state === 'Florida' && <Florida />}
      {state === 'Georgia' && <Georgia />}
      {state === 'Hawaii' && <Hawaii />}
      {state === 'Idaho' && <Idaho />}
      {state === 'Illinois' && <Illinois />}
      {state === 'Indiana' && <Indiana />}
      {state === 'Iowa' && <Iowa />}
      {state === 'Kansas' && <Kansas />}
      {state === 'Kentucky' && <Kentucky />}
      {state === 'Louisiana' && <Louisiana />}
      {state === 'Maine' && <Maine />}
      {state === 'Maryland' && <Maryland />}
      {state === 'Massachusetts' && <Massachusetts />}
      {state === 'Michigan' && <Michigan />}
      {state === 'Minnesota' && <Minnesota />}
      {state === 'Mississippi' && <Mississippi />}
      {state === 'Missouri' && <Missouri />}
      {state === 'Montana' && <Montana />}
      {state === 'Nebraska' && <Nebraska />}
      {state === 'Nevada' && <Nevada />}
      {state === 'New Hampshire' && <NewHampshire />}
      {state === 'New Jersey' && <NewJersey />}
      {state === 'New Mexico' && <NewMexico />}
      {state === 'Ohio' && <Ohio />}
      {state === 'Pennsylvania' && <Pennsylvania />}
      {state === 'Virginia' && <Virginia />}
      {STATE_TERMS[state] && (
        <StateTermsListPdf state={state} items={STATE_TERMS[state]} />
      )}
    </View>
  );
};

export default ContractState;
